import BaseButton from "../BaseButton";
import { BaseSButtonStyle } from "../../../types/Interface";


const buttonStyle: BaseSButtonStyle = {
  width: 200,
  height: 40,
  defaultColor: 0xE13341,
  hoverColor: 0xCF2E3B,
  pressedColor: 0xE13341,
  borderColor: 0xCF2E3B,
  titleColor: 0xEDEDED,
  titleFontSize: 20,
  wordWrapWidth: 200,
  borderRadius: 10
}


export default class CancelAnimationButton extends BaseButton{
  constructor(handleFunc: () => void) {
    super("Cancel Animation", buttonStyle, handleFunc)
    }
}